<template>
  <div>
    <v-data-table :headers="headers" :items="listExpenses" class="elevation-1">
      <template v-slot:item.action="{ item }">
        <v-icon class="mr-2" @click="editItem(item)">edit</v-icon>
        <v-icon @click="deleteItem(item)">delete</v-icon>
      </template>
    </v-data-table>

    <v-layout justify-center>
      <router-link to="/expenses/create">
        <v-btn color="red" fab small dark fixed bottom justify-center>
          <v-icon>add</v-icon>
        </v-btn>
      </router-link>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'ListExpenses',
  data() {
    return {
      headers: [
        {
          text: 'ID',
          align: 'center',
          value: 'id',
          sortable: true,
        },
        {
          text: 'Data',
          align: 'center',
          value: 'date',
          sortable: true,
        },
        {
          text: 'Nr document',
          align: 'center',
          value: 'documentNr',
          sortable: true,
        },
        {
          text: 'Description',
          align: 'center',
          value: 'description',
          sortable: true,
        },
        {
          text: 'Amount',
          align: 'center',
          value: 'amount',
          sortable: true,
        },
        {
          text: 'Actions',
          value: 'action',
          sortable: false,
        },
      ],

      pagination: {
        rowsPerPage: 10,
      },
    };
  },
  created() {
    this.$store.dispatch('expenses/getExpenses',{
      paymentType: this.$route.name === 'Plati Cash' ? 'cash': 'bank'
    });
  },
  watch: {
    '$route'() {
    this.$store.dispatch('expenses/getExpenses',{
      paymentType: this.$route.name === 'Plati Cash' ? 'cash': 'bank'
    });
    }
  },

  computed: {
    listExpenses() {
      return this.$store.state.expenses.expenses;
    },
  },
  methods: {
    editItem(item) {
      const { id } = item;
      this.$router.push({ name: 'Editare plati', params: { id } });
    },
    deleteItem(item) {
      if (window.confirm('Sunteti sigur?')) {
        this.$store.dispatch('expenses/delete', item.id);
      }
    },
  },
};
</script>
